<template>
    <div class="filter-options">
        <b-button
            class="btn-after-chevron-up d-md-none btn-filter-toggle"
            v-b-toggle.shared-assignment-filter
            block
            variant="primary">
            {{ $t('table.filter') }}
        </b-button>

        <b-collapse
            class="shared-assignment-filter"
            id="shared-assignment-filter"
            visible>
            <!--            Education Level Filter-->
            <design-2021-portfolio-edit-shared-assignments-filter-checkbox-component
                v-model="filters.education_levels"
                :title="$t('portfolio.level')"
                filter-key="level"
                :options="educationLevelsOptions">
            </design-2021-portfolio-edit-shared-assignments-filter-checkbox-component>

            <!--            Course Filter-->
            <design-2021-portfolio-edit-shared-assignments-filter-checkbox-component
                v-model="filters.courses"
                :title="$t('portfolio.courses')"
                filter-key="courses"
                :options="coursesOptions">
            </design-2021-portfolio-edit-shared-assignments-filter-checkbox-component>

            <!--            Teacher Filter-->
            <design-2021-portfolio-edit-shared-assignments-filter-checkbox-component
                v-if="databankTypeIn === 'assignment'"
                v-model="filters.teachers"
                :title="$t('portfolio.teachers')"
                filter-key="teachers"
                :options="teachersOptions">
            </design-2021-portfolio-edit-shared-assignments-filter-checkbox-component>

            <!--            Organisation Filter-->
            <design-2021-portfolio-edit-shared-assignments-filter-checkbox-component
                v-model="filters.organisations"
                :title="$t('portfolio.organizations')"
                filter-key="organizations"
                :options="organizationOptions">
            </design-2021-portfolio-edit-shared-assignments-filter-checkbox-component>

            <div class="activity-filter">
                <div
                    class="header"
                    v-b-toggle.activity-filter-options>
                    <label for="activity-filter">{{ $t('portfolio.activity_with_external_party') }}</label>
                    <b-form-checkbox
                        id="activity-filter"
                        v-model="filters.activity"
                        switch>
                    </b-form-checkbox>
                </div>
            </div>

            <!--            Category Filter-->
            <design-2021-portfolio-edit-shared-assignments-filter-checkbox-component
                v-model="filters.categories"
                :title="$t('portfolio.categories')"
                :options="categoriesOptions">
            </design-2021-portfolio-edit-shared-assignments-filter-checkbox-component>

            <b-button
                class="btn-clear-filters"
                variant="primary"
                @click="resetFilters">
                <i class="btn-eraser"></i>{{ $t('portfolio.reset_filters') }}
            </b-button>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'portfolio-edit-shared-assignments-filters-component',
    props: {
        value: Object,
        educationLevels: Array,
        assignmentsIn: Array,
        databankTypeIn: {
            String,
            default: 'assignment',
        },
    },

    data() {
        return {
            educationLevelsOptions: this.educationLevels.map((education) => {
                return {
                    value: education.id,
                    text: education.name,
                };
            }),
            coursesOptions: [],
            teachersOptions: [],
            organizationOptions: [],
            hasActivity: false,
            filters: {
                education_levels: [],
                courses: [],
                teachers: [],
                organisations: [],
                activity: true,
                categories: [],
            },
        };
    },

    mounted() {
        this.$emit('input', this.filters);
        if (this.databankTypeIn === 'assignment') {
            this.getTeachers();
        }
        this.getCourses();
        this.getOrganizations();
    },
    methods: {
        updateFilter(value, filterKey) {
            if (filterKey === 'level') {
                if (value.length > 0) {
                    this.filters.education_levels = [];
                    value.forEach((level) => {
                        for (let i = 0; i < this.educationLevelsOptions.length; i++) {
                            if (this.educationLevelsOptions[i].value === level) {
                                this.filters.education_levels.push(this.educationLevelsOptions[i].text);
                                break;
                            }
                        }
                    });
                }
            }

            if (filterKey === 'courses') {
                this.filters.courses = value;
            }

            if (filterKey === 'teachers') {
                this.filters.teachers = value;
            }

            if (filterKey === 'organizations') {
                this.filters.organisations = value;
            }

            if (filterKey === 'activity') {
                this.filters.activity = value;
            }

            if (filterKey === 'categories') {
                this.filters.categories = value;
            }

            if (filterKey === 'reset') {
                this.filters.education_levels = [];
                this.filters.courses = [];
                this.filters.teachers = [];
                this.filters.organisations = [];
                this.filters.activity = true;
                this.filters.categories = [];
            }

            this.$emit('input', this.filters);
        },

        getCourses() {
            let courses = [];
            for (const assignment of this.assignmentsIn) {
                assignmentCourseLoop: for (const assignmentCourse of assignment.courses) {
                    for (const course of courses) {
                        if (course.id === assignmentCourse.id) {
                            continue assignmentCourseLoop;
                        }
                    }
                    courses.push(assignmentCourse);
                }
            }

            this.coursesOptions = courses.map((course) => {
                return {
                    value: course.id,
                    text: course.name,
                };
            });
        },

        getTeachers() {
            if (this.assignmentsIn.length) {
                let teachersTemp = {};
                const rawAssignments = this.assignmentsIn
                    .filter((assignment) => !!assignment.publisher)
                    .map((assignment) => {
                        return {
                            value: assignment.publisher.id,
                            text: assignment.publisher.full_name,
                        };
                    });

                this.teachersOptions = rawAssignments.filter(
                    (assignment) => !teachersTemp[assignment.value] && (teachersTemp[assignment.value] = true),
                );
            }
        },

        getOrganizations() {
            const all_organizations = this.assignmentsIn
                .filter((assignment) => {
                    if (assignment.paid && !this.$authUser.isAdmin()) {
                        return false;
                    }

                    return assignment.assignment.organization_assignment_folder.length;
                })
                .map((assignment) => {
                    return {
                        value: assignment.assignment.organization_assignment_folder[0].organization.id,
                        text: assignment.assignment.organization_assignment_folder[0].organization.name,
                    };
                });

            let organizations = [];
            allLoop: for (const organization_option of all_organizations) {
                for (const organization of organizations) {
                    if (organization.value === organization_option.value) {
                        continue allLoop;
                    }
                }
                organizations.push(organization_option);
            }
            this.organizationOptions = organizations;
        },

        resetFilters() {
            this.filters = {
                education_levels: [],
                courses: [],
                teachers: [],
                organisations: [],
                activity: true,
                categories: [],
            };

            this.hasActivity = false;

            this.$emit('input', this.filters);
        },
    },

    computed: {
        categoriesOptions() {
            let categories = [];

            for (const assignment of this.assignmentsIn) {
                assignmentCategoryLoop: for (const assignmentCategory of assignment.categories) {
                    for (const category of categories) {
                        if (category.id === assignmentCategory.id) {
                            continue assignmentCategoryLoop;
                        }
                    }
                    categories.push(assignmentCategory);
                }
            }

            return categories.map((category) => {
                return {
                    value: category.id,
                    text: category.name,
                };
            });
        },
    },
    watch: {
        assignmentsIn: function () {
            this.getTeachers();
            this.getCourses();
            this.getOrganizations();
            this.$emit('input', this.filters);
        },

        value: function (newVal) {
            this.filters = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
.btn-clear-filters {
    display: flex;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

//Legacy=======================================================
.shared-assignment-filter {
    padding: 0 map-get($grid-gutter-spacing, 'forty-two');

    i {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.btn-filter-toggle {
    display: flex;
    justify-content: space-between;
    font-weight: $font-weight-medium;
    padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
}

.btn-filter-toggle i {
    transition: all 0.8s ease;
    transform-origin: center;
}

.btn-filter-toggle.collapsed i {
    transform: rotate(180deg);
}

.activity-filter {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    flex-direction: row;
}

.activity-filter .header {
    display: flex;
    column-gap: map-get($grid-gutter-spacing, 'eight');
    justify-content: space-between;
    padding-bottom: map-get($grid-gutter-spacing, 'five');
    margin-bottom: map-get($grid-gutter-spacing, 'five');
    border-bottom: 1px solid $border-color;
    flex-direction: row;
}

.activity-filter label {
    font-weight: $font-weight-medium;
    margin-bottom: 0;
}

@media (min-width: 768px) {
    .shared-assignment-filter {
        padding: 0;
    }
}

@media (min-width: 1200px) {
    .activity-filter {
        max-width: 70%;
    }
}
</style>
